import { ModalState } from './types';

const initialModalState: ModalState = {
  modalOpenExportBills: false,
  modalOpenUserAction: false,
  modalOpenTag: false,
  modalIsPublishTag: false,
  modalOpenLoginRestriction: false,
  modalOpenOptionalLogin: true,
  modalOpenSavedSearch: false,
  modalSavedSearchCriteria: {},
  modalOpenEditSearch: false,
  modalEditSearchAction: 'rename',
  modalOpenSavedSearchAlert: false,
  modalOpenSavedSearchAlertSubscribed: false,
  modalOpenSavedSearchAlertError: false,
  modalOpenReportProblem: false,
};

export default initialModalState;
